<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="primary" size="small" @click="addSwiopeAction"  icon="el-icon-plus" plain>添加</el-button>
                         <el-input
                            size="small"
                            style="width:200px;margin-left:5px"
                            placeholder="请输入旺旺号 / 手机 / QQ"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-select size="small" style="margin-left:5px;width:100px"   v-model="queryModel.status" clearable placeholder="刷手状态">
                            <el-option key="1" label="正常" value="1"> </el-option>
                            <el-option key="2" label="待认证" value="2"> </el-option>
                            <el-option key="3" label="审核中" value="3"> </el-option>
                            <el-option key="4" label="审核失败" value="4"> </el-option>
                            <el-option key="5" label="封停" value="5"> </el-option>
                            <el-option key="5" label="不做单" value="6"> </el-option>
                        </el-select>
                        <el-select size="small" style="margin-left:5px;width:100px"   v-model="queryModel.grade" clearable placeholder="刷手等级">
                            <el-option key="1" label="1(级)" :value="1"> </el-option>
                            <el-option key="2" label="2(级)" :value="2"> </el-option>
                            <el-option key="3" label="3(级)" :value="3"> </el-option>
                            <el-option key="4" label="4(级)" :value="4"> </el-option>
                            <el-option key="5" label="5(级)" :value="5"> </el-option>
                            <el-option key="6" label="6(级)" :value="6"> </el-option>
                        </el-select>
                        <el-select size="small" style="margin-left:5px;width:100px"   v-model="queryModel.souce" clearable placeholder="刷手来源">
                            <el-option key="1" label="注册" value="1"> </el-option>
                            <el-option key="2" label="后台添加" value="2"> </el-option>
                        </el-select>
                        <el-select size="small" style="margin-left:5px;width:100px"  filterable   v-model="queryModel.managerId" clearable placeholder="审核人">
                            <el-option v-for="v in managerList" :key="v.Id" :label="v.RealName" :value="v.Id"> </el-option>
                        </el-select>
                        <el-date-picker
                        size="small" style="width:230px;margin-left:5px"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="注册时间起"
                        end-placeholder="注册时间止">
                        </el-date-picker>
                        <el-date-picker
                        size="small" style="width:230px;margin-left:5px"
                        v-model="queryModel.reviewTimes"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="审核时间起"
                        end-placeholder="审核时间止">
                        </el-date-picker>
                        
                        <el-checkbox style="margin-left:5px" v-model="queryModel.isNever">从未刷单</el-checkbox>
                        
                        <el-checkbox  v-model="queryModel.myFission">我介绍的</el-checkbox>

                         <!-- <el-checkbox  v-model="queryModel.hasMeWechat">有我微信</el-checkbox> -->

                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:10px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:5px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>

                        <b style="font-size:13px;margin-left:10px">余额总计：</b>
                        <el-tag class="tag_btn" size="mini"  type="danger" effect="dark">￥{{moneyTotal.toFixed(2)}}</el-tag>
                    </div>
                    <div style="text-align:center">
                        <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    :data="tableData"
                    v-loading="isLoading"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                            width="80px"
                            label="Id">
                            <template slot-scope="scope">
                                {{scope.row.Id}}
                                  
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="70px"
                            prop="Name"
                            label="名称">
                        </el-table-column>

                        <el-table-column
                        width="120"
                            prop="Phone"
                            label="手机">
                        </el-table-column>
                        <el-table-column
                        width="140"
                            prop="AliTrademanager"
                            label="阿里旺旺">
                        </el-table-column>
                        <el-table-column
                        width="90px"
                            label="等级/初始">
                            <template slot-scope="scope">
                                    <el-popover
                                        placement="bottom"
                                        trigger="hover">
                                        <div >
                                            <el-button  @click="changeGrade(scope.row,1)" size="mini" >1级</el-button>
                                            <el-button  @click="changeGrade(scope.row,2)" size="mini" >2级</el-button>
                                            <el-button  @click="changeGrade(scope.row,3)" size="mini" >3级</el-button>
                                            <el-button  @click="changeGrade(scope.row,4)" size="mini" >4级</el-button>
                                            <el-button  @click="changeGrade(scope.row,5)" size="mini" >5级</el-button>
                                            <el-button  @click="changeGrade(scope.row,6)" size="mini" >6级</el-button>
                                        </div>
                                       <el-tag  class="tag_btn"  slot="reference" size="mini" type="" effect="dark">{{scope.row.Grade+' / '+scope.row.InitialGrade}}</el-tag>
                                    </el-popover>
                            </template>

                        </el-table-column>
                        <!-- <el-table-column
                        width="150"
                            label="微信">
                            <template slot-scope="scope" >
                                <template v-if="scope.row.WeChat">
                                    <el-popover
                                        placement="bottom"
                                        trigger="hover">
                                        <div style="text-align:center" v-for="item in managerWechatList" :key="item.Id">
                                            <el-button @click="bindWechat(scope.row,item)" size="mini" >{{item.NickName+'('+item.WeChat+')'}}</el-button>
                                        </div>
        
                                        <el-link slot="reference" size="mini" type="info">
                                            <i class="el-icon-plus" style="cursor: pointer;"></i>
                                        </el-link>
                                    </el-popover>
                                &nbsp;
                                <el-tooltip class="item" v-if="scope.row.ManagerWechatList.length==0" effect="dark" content="暂无微信所有者信息" placement="bottom">
                                    <el-link type="info">{{scope.row.WeChat}}</el-link>
                                </el-tooltip>
                                <el-tooltip v-else  class="item" effect="dark" placement="bottom">
                                    <div slot="content">
                                        <p v-for="(v,i) in scope.row.ManagerWechatList" :key="i">
                                            <b>{{v.Name}}</b>
                                            ({{v.WeChat+":"+v.NickName}})
                                            <br/>
                                        </p>
                                    </div>
                                    <el-link type="info">{{scope.row.WeChat}}</el-link>
                                </el-tooltip>
                                </template>

                                <template v-else>
                                      <el-link @click="swipeAddWechat(scope.row)" type="primary">绑定微信</el-link>
                                </template>
                            </template>
                        </el-table-column> -->
                        <el-table-column
                        width="100"
                            label="QQ群">
                            <template slot-scope="scope">
                                    <el-popover
                                        placement="bottom"
                                        trigger="hover">
                                        <div style="text-align:center" v-for="item in qqGroup" :key="item.Id">
                                            <el-button style="margin-top:5px;margin-bottom:5px" @click="bindQQ(scope.row,item.Id)" size="mini" >{{item.Name+'('+item.QQ+')'}}</el-button>
                                        </div>
                                        <el-tag  slot="reference" v-if="scope.row.QQGroupName" size="mini">{{scope.row.QQGroupName}}</el-tag>
                                        <el-tag  slot="reference" v-else size="mini" type="info">暂无</el-tag>
                                    </el-popover>
                            </template>
                        </el-table-column>

                        <el-table-column
                        width="100"
                            label="累计佣金">
                            <template slot-scope="scope">
                                <el-tag class="tag_btn" size="mini" type="danger" effect="dark">￥{{scope.row.GrandTotal}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="100"
                            label="余额">
                            <template slot-scope="scope">
                                <el-link @click="openSetBalance(scope.row)"  icon="el-icon-money" type="primary">￥{{scope.row.Balance}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="100"
                            label="是否允许推广">
                            <template slot-scope="scope">
                                <el-link @click="setHasPromote(scope.row)"   type="primary">
                                    <template v-if="scope.row.HasPromote">是</template>
                                    <template v-else >否</template>
                                </el-link>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column
                            prop="IdCardNumber"
                            width="180"
                            label="身份证号">
                        </el-table-column> -->
                        <el-table-column
                            width="80"
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="success" v-if="scope.row.Status==1">正常</el-tag>
                                <el-tag size="mini" effect="plain"  v-else-if="scope.row.Status==2">待认证</el-tag>
                                <template v-else-if="scope.row.Status==3">
                                    <el-tag size="mini" effect="plain" type="warning" v-if="!scope.row.NeedProve">审核中</el-tag>
                                    <el-tag size="mini" effect="plain" type="warning" v-else-if="scope.row.NeedProve&&scope.row.ProveNum==0">等传资料</el-tag>
                                    <el-tag size="mini" effect="plain" type="warning" v-else-if="scope.row.NeedProve&&scope.row.ProveNum>0">已传资料</el-tag>

                                </template>
                                <el-tag size="mini" effect="plain" type="danger" v-else-if="scope.row.Status==4">审核不通过</el-tag>
                                <el-tooltip class="item" v-else-if="scope.row.Status==5" effect="dark" :content="scope.row.Reason" placement="bottom">
                                    <el-tag size="mini" effect="plain" type="info" >封停</el-tag>
                                </el-tooltip>
                                <el-tag size="mini" effect="plain" type="info" v-else>不做单</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            width="160"
                            label="注册时间">
                        </el-table-column>
                        
                        <el-table-column
                        width="90"
                            label="审核人">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.AssistStatus==1" size="mini" type="danger">担保中</el-tag>
                                <el-tag v-else-if="scope.row.AssistStatus==2" size="mini" type="success">已担保</el-tag>
                                <el-tag v-else-if="scope.row.ManageName" size="mini">{{scope.row.ManageName}}</el-tag>
                                <el-tag v-else size="mini" type="info">暂无</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="60"
                            label="资料">
                            <template slot-scope="scope">
                                  <el-link type="primary" @click="getProve(scope.row)" v-if="scope.row.ProveNum>0">{{scope.row.ProveNum}}</el-link>
                                  <el-link type="primary" v-else>暂无</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="270px"
                        fixed="right"
                            label="更多信息">
                            <template slot-scope="scope">
                                <el-link type="primary" @click="showChild(scope.row)">上下级</el-link>
                                &nbsp;
                                <el-link @click="showDervice(scope.row)" type="primary">设备</el-link>
                                &nbsp;
                                <el-link v-if="manger.Role==1||manger.Role==5" @click="getContact(scope.row)" type="primary">通讯录</el-link>
                                &nbsp;
                                <router-link style="text-decoration:none" :to="{path:'/order', query:{queryTxt:scope.row.Phone}}" target="_blank">
                                    <el-link type="primary">刷单记录</el-link>
                                </router-link>
                                &nbsp;
                                <el-link v-if="(manger.Role==1||manger.Role==5 )&&scope.row.IsVerify" @click="showInfo(scope.row)" type="primary">实名信息</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="420px"
                        fixed="right"
                            label="操作">
                            <template slot-scope="scope">
                                <!-- <el-tooltip class="item" v-if="scope.row.Status!=3"   effect="dark" content="添加用户的刷单记录" placement="bottom">
                                    <el-button size="mini" @click="addSwipeRecordAction(scope.row)" >加记录</el-button>
                                </el-tooltip> -->
                                <el-tooltip class="item" v-if="scope.row.Status==1" effect="dark" content="禁止接单" placement="bottom">
                                    <el-button type="" size="mini" @click="noOrderAction(scope.row)" >禁单</el-button>
                                </el-tooltip>

                                <el-tooltip class="item" v-if="scope.row.Status==1" effect="dark" content="封停用户，无法使用" placement="bottom">
                                    <el-button type="danger" size="mini" @click="deactivate(scope.row)" >封号</el-button>
                                </el-tooltip>


                                <el-tooltip class="item" v-if="scope.row.Status==1&&manger.Role==1" effect="dark" content="标记为永不做单" placement="bottom">
                                    <el-button  type="warning" size="mini" @click="buzuodan(scope.row)">永不做单</el-button>
                                </el-tooltip>

                                <el-tooltip class="item" v-if="scope.row.Status==1&&manger.Role==1" effect="dark" content="重新认证" placement="bottom">
                                    <el-button  type="primary" size="mini" @click="cxrz(scope.row)">重新认证</el-button>
                                </el-tooltip>

                                <el-tooltip class="item" v-if="scope.row.Status==6&&manger.Role==1" effect="dark" content="恢复做单" placement="bottom">
                                    <el-button  type="primary"  @click="huifu(scope.row)" size="mini" >恢复做单</el-button>
                                </el-tooltip>


                                <template v-else-if="scope.row.Status==3&&scope.row.AssistStatus==0&&(!scope.row.NeedProve||scope.row.ProveNum>0)">
                                    <el-popover
                                        placement="bottom"
                                        trigger="hover">
                                        <span style="text-align:center" v-for="item in 3" :key="item">
                                            <el-button style="margin-left:5px;margin-right:5px" 
                                            @click="passAction(scope.row,item)" 
                                            size="mini" >{{item+'(级)'}}</el-button>
                                        </span>
                                         <el-button style="margin-right:10px" type="success" slot="reference" size="mini"  >通过</el-button>
                                    </el-popover>
                                    <el-tooltip class="item"  effect="dark" content="审核不通过" placement="bottom">
                                        <el-button type="danger" size="mini" @click="fail(scope.row)" >不通过</el-button>
                                    </el-tooltip>
                                    <el-tooltip class="item"  effect="dark" content="转担保" placement="bottom">
                                        <el-button  type="primary" size="mini" @click="assist(scope.row)" >转担保</el-button>
                                    </el-tooltip>
                                </template>
                                <el-tooltip class="item" v-else-if="scope.row.Status==5" effect="dark" content="解封用户，正常使用" placement="bottom">
                                    <el-button type="success" size="mini" @click="enable(scope.row)">启用</el-button>
                                </el-tooltip>
                                <el-tooltip class="item" v-if="scope.row.Status==3&&scope.row.AssistStatus==0" effect="dark" content="要求上传辅助资料" placement="bottom">
                                    <el-button type="success" size="mini" v-if="scope.row.NeedProve&&scope.row.ProveNum>0"  
                                        @click="setProve(scope.row)">重传资料</el-button>
                                    <el-button type="success" size="mini" v-else @click="setProve(scope.row)">要求资料</el-button>
                                </el-tooltip>
                                <el-tooltip class="item"  effect="dark" content="清理脚本" placement="bottom">
                                        <el-button type="danger" size="mini" @click="clearScript(scope.row)" >清理脚本</el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-image-viewer 
                style="z-index:999999"
                v-if="showViewer" 
                :on-close="closeImg" 
                :url-list="imgList" />
        <el-dialog title="添加刷手" :visible.sync="addSwiopeVisible"  width="400px">
            <el-form  label-width="60px" :model="newSwipe"  :rules="rules" ref="ruleForm">
                <el-form-item label="手机" prop="phone">
                    <el-input   v-model="newSwipe.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="QQ">
                    <el-input   v-model="newSwipe.qq" placeholder="请输入qq号"></el-input>
                </el-form-item>
                 <el-form-item label="微信">
                    <el-input   v-model="newSwipe.wechat" placeholder="请输入微信号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addSwiopeVisible = false">取 消</el-button>
                <el-button type="primary" @click="addSwiope">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog  title="通讯录" :visible.sync="contactVisible" width="1400px">
            <el-row v-loading="repeatLoading">
                <el-col :span="8" style="border-right:solid 1px #DCDFE6">
                    <div>
                        <el-input size="small" placeholder="请输入手机号码" v-model="queryContactValue" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search" @click="queryContact"></el-button>
                        </el-input>
                    </div>
                    <el-table :data="contactsTableData" height="600">
                        <el-table-column property="Name" label="联系人" ></el-table-column>
                        <el-table-column property="Phone" label="手机号" ></el-table-column>
                    </el-table>
                </el-col>
                <el-col :span="16">
                    <div style="width:100%;">
                          <el-button @click="getRepeatContact" style="float:right;margin-right:20px" size="small">重复查询</el-button>
                    </div>
                    <el-table :data="repeatContacts" height="600">
                        <el-table-column
                            width="100px"
                            label="Id">
                            <template slot-scope="scope">
                                {{scope.row.SwipeId}}
                                  <el-tag style="cursor:pointer"   type="danger" size="mini" v-if="!scope.row.SwipeIsOld" effect="plain">新</el-tag>
                                  <el-tag style="cursor:pointer"   type="success" size="mini" v-else effect="plain">老</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="70px"
                            prop="SwipeName"
                            label="名称">
                        </el-table-column>
                        <el-table-column
                        width="120"
                            prop="SwipePhone"
                            label="手机">
                        </el-table-column>
                        <el-table-column
                            prop="SwipeCreateTime"
                            width="160"
                            label="注册时间">
                        </el-table-column>
                        <el-table-column
                            width="80"
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="success" v-if="scope.row.SwipeStatus==1">正常</el-tag>
                                <el-tag size="mini" effect="plain"  v-else-if="scope.row.SwipeStatus==2">待认证</el-tag>
                                <el-tag size="mini" effect="plain" type="warning" v-else-if="scope.row.SwipeStatus==3">审核中</el-tag>
                                <el-tag size="mini" effect="plain" type="danger" v-else-if="scope.row.SwipeStatus==4">审核不通过</el-tag>
                                 <el-tag size="mini" effect="plain" v-else-if="scope.row.SwipeStatus==5" type="info" >封停</el-tag>
                                <el-tag size="mini" effect="plain" type="info" v-else>不做单</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column property="Name" label="通讯录联系人" ></el-table-column>
                        <el-table-column property="Phone" label="通讯录手机号" ></el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-dialog>
        <el-dialog title="上下级" :visible.sync="childVisible" width="800px">
            <el-table :data="childs" height="600" row-key="Id" :default-expand-all="true"   :tree-props="{children: 'children'}">
                        <el-table-column
                            label="手机">
                            <template slot-scope="scope">
                                <span style="color:#F56C6C" v-if="scope.row.Id==setRow.Id">{{scope.row.Phone}}</span>
                                <span  v-else>{{scope.row.Phone}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="90px"
                            label="等级/初始">
                            <template slot-scope="scope">
                                <el-tag  class="tag_btn" size="mini" type="" effect="dark">{{scope.row.Grade+' / '+scope.row.InitialGrade}}</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column
                        width="80"
                            prop="Name"
                            label="名称">
                        </el-table-column>
                        <el-table-column
                        width="120"
                            prop="QQ"
                            label="QQ">
                        </el-table-column>
                        <el-table-column
                         width="130"
                            prop="AliTrademanager"
                            label="阿里旺旺">
                        </el-table-column>
                        <el-table-column
                            width="80"
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="success" v-if="scope.row.Status==1">正常</el-tag>
                                <el-tag size="mini" effect="plain"  v-else-if="scope.row.Status==2">待认证</el-tag>
                                <el-tag size="mini" effect="plain" type="warning" v-else-if="scope.row.Status==3">审核中</el-tag>
                                <el-tag size="mini" effect="plain" type="danger" v-else-if="scope.row.Status==4">审核不通过</el-tag>
                                <el-tag size="mini" effect="plain" type="info" v-else-if="scope.row.Status==5">封停</el-tag>
                                <el-tag size="mini" effect="plain" type="info" v-else>永不做单</el-tag>
                            </template>
                        </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog title="禁止接单" :visible.sync="noOrderVisible" width="800px">

            <el-form :inline="true" :model="noOrder" >
                <el-form-item label="原因：">
                      <el-select
                      size="small"
                        v-model="noOrder.reason"
                        placeholder="请选择禁止原因">
                            <el-option
                            label="使用红包"
                            :value="1">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="天数：">
                    <el-input-number size="small" v-model="noOrder.days"   :min="1"   label="禁止接单天数"></el-input-number>
                </el-form-item>
            </el-form>
                <el-table
                :data="noOrderList"
                style="width: 100%">
                <el-table-column
                    prop="ReasonName"
                    label="封禁原因">
                </el-table-column>
                <el-table-column
                    prop="OverTime"
                    label="结束时间"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="CreateTime"
                    label="封禁时间"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="ManagerName"
                    label="操作人">
                </el-table-column>
                </el-table>


            <div slot="footer" class="dialog-footer">
                <el-button @click="noOrderVisible = false">取 消</el-button>
                <el-button type="primary" @click="noOrderSumbit">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="添加刷单记录" :visible.sync="addSwipeRecordVisible" width="400px">
            <el-form  :model="swipeRecordModel"  label-width="100px">
                <el-form-item label="店铺：">
                      <el-select
                        v-model="swipeRecordModel.shopId"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入商家名称"
                        :remote-method="remoteMethod"
                        :loading="shopLoading">
                            <el-option
                            v-for="item in shopList"
                            :key="item.Key"
                            :label="item.Value"
                            :value="item.Key">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期：">
                        <el-date-picker
                        v-model="swipeRecordModel.date"
                        type="date"
                        placeholder="请选择选择日期">
                        </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addSwipeRecordVisible = false">取 消</el-button>
                <el-button type="primary" @click="addSwipeRecord">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="设备" :visible.sync="derviceVisible" width="500px">
            <el-form   label-width="110px">
                <el-form-item label="机型">
                    <el-radio-group v-model="dervice.EquipmentType">
                        <el-radio :label="1">安卓</el-radio>
                        <el-radio :label="2">苹果</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Imei：">
                    <el-input disabled size="small" v-model="dervice.Imei"></el-input>
                </el-form-item>
                <el-form-item label="Ip：">
                    <el-input disabled size="small" v-model="dervice.Ip"></el-input>
                </el-form-item>
                <el-form-item label="Cid：">
                    <el-input disabled size="small" v-model="dervice.Cid"></el-input>
                </el-form-item>
                <el-form-item label="经度：">
                    <el-input disabled size="small" v-model="dervice.Longitude"></el-input>
                </el-form-item>
                <el-form-item label="纬度：">
                    <el-input disabled size="small" v-model="dervice.Latitude"></el-input>
                </el-form-item>
                <el-form-item label="最后使用：">
                    <el-input disabled size="small" v-model="dervice.LastUseTime"></el-input>
                </el-form-item>

</el-form>
        </el-dialog>
        <el-dialog title="修改余额" :visible.sync="dialogFormVisible" width="400px">
            <el-form   label-width="80px">
                <el-form-item label="类型：" prop="Title">
                      <el-radio-group v-model="setBalanceModel.Type">
                            <el-radio :label="9">资损追回</el-radio>
                            <el-radio :label="10">财务多转</el-radio>
                        </el-radio-group>
                </el-form-item>
                <el-form-item label="金额：" >
                    <el-input v-model="setBalanceModel.Money" placeholder="￥"></el-input>
                </el-form-item>
                <el-form-item label="备注：" >
                    <el-input v-model="setBalanceModel.Description" placeholder="请输入备注信息"></el-input>
                </el-form-item>
                <el-form-item v-show="setBalanceModel.Type==10" label="出纳：" >
                    <el-select size="small" filterable   style="margin-left:0px;width:100px"   v-model="setBalanceModel.OutsiderId" clearable placeholder="兼职人员">
                        <el-option v-for="(v) in outsiderList" :key="v.Id" :label="v.Name" :value="v.Id"> </el-option>
                    </el-select>
                </el-form-item>
                        
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="setBalance">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
        title="实名信息"
        :visible.sync="infoVisible"
        width="30%">
        <div>
                <b>
                    身份证号码：{{setRow.IdCardNumber}}
                </b>
            </div>
            <div style="margin-top:20px;">
                <b>实名照片：</b>
                  <el-image 
                        style="width: 200px; height: 200px"
                        :src="setRow.Photo" 
                        :preview-src-list="setRow.Photo">
                    </el-image>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {swipeGetNoOrder,swipeSwipeNoOrder,swipeRecertification, swipeSetGrade,outsiderGetSel, swipeSetStatus,swipeGetRepeatContact,swipeSetQQgroup,swipeBindWechat,swipeSetAssist,swipeGetDevice,managerWechatSwipeBind, managerWechatGet,swipeSetIsOld,swipeAdd,managerGetSel,
qqGroupGet,orderAddOrder,shopQuery,swipeGet,swipeFail,swipePass,swipeDisable,swipeEnable,swipeGetContact,swipeGetChild,swipeGetProve,swipeSetProve,swipeModifyBalance,swipeClearScript,swipeSetHasPromote} from '@/request.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    props:{
      manger:{
        type:Object,
        required: true
      }
    },
    components: {
        ElImageViewer
    },
    data(){
        return {
            noOrderList:[],
            noOrderVisible:false,
            noOrder:{
                reason:1,
                days:1,
                swipeId:0,
            },
            infoVisible:false,
            derviceVisible:false,
            dialogFormVisible:false,
            moneyTotal:0,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
                status:"",
                grade:"",
                createTimes:[],
                managerId:"",
                isNever:false,
                reviewTimes:[],
                souce:"",
                myFission:false,
                hasMeWechat:false,
            },
            tableData:[],
            setRow:{},
            gradeDisabled:false,
            contacts:[],
            contactsTableData:[],
            contactVisible:false,
            childVisible:false,
            childs:[],
            swipeRecordModel:{
                shopId:"",
                date:"",
                swipeId:0
            },
            shopList:[],
            shopLoading:false,
            addSwipeRecordVisible:false,
            qqGroup:[],
            managerList:[],
            newSwipe:{
                qq:"",
                phone:"",
                wechat:"",
            },
            addSwiopeVisible:false,
            rules: {
                phone: [
                    { required: true, message: '请填写手机号码', trigger: 'blur' },
                    { min: 11, max: 11, message: '长度为 11 个字符', trigger: 'blur' }
                ],
            },
            managerWechatList:[],
            isUpdate:false,
            dervice:{},
            queryContactValue:"",
            repeatContacts:[],
            repeatLoading:false,
            imgList:[],
            showViewer:false,
            setBalanceModel:{
                SwipeId:0,
                Type:10,
                Money:0,
                Description :"",
                Balance:0,
                OutsiderId:0,
            },
            setBalanceRow:{},
            outsiderList:[],
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
        // alert("a");
        qqGroupGet({},(res)=>{
            this.qqGroup=res.Result;
        });
        managerGetSel({},(res)=>{
            this.managerList=res.Result;
        });
        managerWechatGet({},(res)=>{
            this.managerWechatList=res.Result;
        });
        outsiderGetSel({type:1},(res)=>{
           this.outsiderList=res.Result;
       });
    },
    methods: {
        noOrderSumbit(){
            swipeSwipeNoOrder(this.noOrder,(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.noOrderVisible=false;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        noOrderAction(scope){
            swipeGetNoOrder({swipeId:scope.Id},(res)=>{
                this.noOrderList=res.Result;
            })
            
            this.noOrder={
                swipeId:scope.Id,
                days:1,
                reason:1
            }
            this.noOrderVisible=true;
        },
        cxrz(scope){
                this.$confirm('确定将该刷手恢复正常吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    swipeRecertification({
                        swipeId:scope.Id
                    },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.Status=2;
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                }).catch(() => {
     
                });
        },
        changeGrade(scope,grade){
            swipeSetGrade({swipeId:scope.Id,grade:grade},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.Grade=grade;
                        }else{
                            this.$message.error(res.Message);
                        }
            });
        },
        huifu(scope){
                this.$confirm('确定将该刷手恢复正常吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    swipeSetStatus({
                        id:scope.Id,
                        status:1
                    },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.Status=1;
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                }).catch(() => {
     
                });
        },
            buzuodan(scope){
                this.$confirm('确定标记该刷手为不做单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    swipeSetStatus({
                        id:scope.Id,
                        status:6
                    },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.Status=6;
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                }).catch(() => {
     
                });
        },
        setHasPromote(scope){
                var tit = '';
                if(scope.HasPromote)
                {
                    tit='不允许该刷手推广?';
                }
                else{
                    tit='允许该刷手推广?';
                }
                this.$confirm(tit, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    swipeSetHasPromote({
                        id:scope.Id,
                        hasPromote:scope.HasPromote?false:true,
                    },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.HasPromote=scope.HasPromote?false:true;
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                }).catch(() => {
     
                });
        },
        showInfo(scope){
            this.setRow=scope;
            this.infoVisible=true;
        },
        setProve(scope){
            this.$confirm('确认要求该会员上传身份证吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                swipeSetProve({
                    swipeId:scope.Id,
                },(res)=>{
                    if(res.IsSuccess){
                        scope.ProveNum=0;
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            message: '操作失败',
                            type: 'success'
                        });
                    }
                });
            }).catch(() => { 
            });

        },
        openSetBalance(info) {
            if(this.manger.Role!=1 && this.manger.Role!=3  ){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.setBalanceModel={
                SwipeId:info.Id,
                Type:9,
                Money:0,
                Description :"",
                Balance:info.Balance,
                OutsiderId:0,
            }
            this.setBalanceRow = info
            this.dialogFormVisible = true
        },
        setBalance(){
            var money=this.setBalanceModel.Money;
            if(money==""||isNaN(money)){
                this.$message({
                    message: '请填写正确的金额',
                    type: 'warning'
                });
                return;
            }
            if(parseFloat(money)<=0){
                this.$message({
                    message: '金额必须大于零',
                    type: 'warning'
                });
                return;
            }
            swipeModifyBalance(this.setBalanceModel,(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        if(this.setBalanceModel.Type==9)
                            this.setBalanceRow.Balance+=parseFloat(this.setBalanceModel.Money);
                        else
                            this.setBalanceRow.Balance-=parseFloat(this.setBalanceModel.Money);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
        },
        closeImg(){
            this.showViewer=false;
        },
        getProve(scope){
            swipeGetProve({
                swipeId:scope.Id
            },(res)=>{
                this.imgList=res.Result;
                this.showViewer=true;
            });
        },
        getRepeatContact(){
            this.repeatLoading=true;
            swipeGetRepeatContact({swipeId:this.setRow.Id},(res)=>{
                this.repeatContacts=res.Result;
                this.repeatLoading=false;
                if(this.repeatContacts==null||this.repeatContacts.length==0){
                    this.$message({
                    message: '系统内没有与该用户通讯录重复的记录',
                    type: 'success'
                    });
                }
            });
        },
        queryContact(){
            if(this.queryContactValue){
                this.contactsTableData=[];
                this.contacts.forEach(x=>{
                    if(x.Phone.replaceAll(/-/g, "").replaceAll(/ /g, "")==this.queryContactValue.replaceAll(/-/g, "").replaceAll(/ /g, "")){
                        this.contactsTableData.push(x);
                    }
                });
            }else{
                this.contactsTableData=this.contacts;
            }
        },
        bindQQ(scope,qqGroupId){
            swipeSetQQgroup({swipeId:scope.Id,qqGroupId:qqGroupId},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '绑定成功',
                        type: 'success'
                    });
                    scope.QQGroupName=res.Result;
                    scope.QQGroup=qqGroupId;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        swipeAddWechat(scope){
            this.$prompt('请填写刷手微信号', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^.{2,30}$/,
            inputErrorMessage: '长度限制为2-30'
            }).then(({ value }) => {
                swipeBindWechat({swipeId:scope.Id,wechat:value},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '绑定成功',
                            type: 'success'
                        });
                        scope.WeChat=value;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch((e) => {
                console.log(e);
            });
        },
        assist(scope){
            this.$confirm('确认转为推荐人担保审核吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                swipeSetAssist({swipeId:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.AssistStatus=1;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => { 
            });
        },
        showDervice(scope){
            swipeGetDevice({swipeId:scope.Id},(res)=>{
                this.derviceVisible=true;
                this.dervice=res.Result;
            });
        },
        bindWechat(scope,managerWechat){
            managerWechatSwipeBind({
                swipeId:scope.Id,
                managerWechatId:managerWechat.Id
            },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '绑定成功',
                            type: 'success'
                        });
                        scope.ManagerWechatList.push(managerWechat);
                    }else{
                        this.$message.error(res.Message);
                    }
            });
        },
        setOld(scope){
            this.$confirm('确定将该用户标记为'+(scope.IsOld?'新':'老')+'用户吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                swipeSetIsOld({swipeId:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.IsOld=!scope.IsOld;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        addSwiopeAction(){
            this.newSwipe={
                qq:"",
                phone:"",
            }
            this.addSwiopeVisible=true;
        },
        addSwiope(){
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    swipeAdd(this.newSwipe,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.addSwiopeVisible=false;
                            this.query();
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        addSwipeRecord(){
            if(this.swipeRecordModel.shopId==""){
                this.$message({
                    message: "请先选择店铺",
                    type: 'warning'
                });
                return;
            }
            if(this.swipeRecordModel.data==""){
                this.$message({
                    message: "请先选择日期",
                    type: 'warning'
                });
                return;
            }
            orderAddOrder(this.swipeRecordModel,(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.addSwipeRecordVisible=false;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        addSwipeRecordAction(scope){
            this.swipeRecordModel={
                shopId:"",
                date:"",
                swipeId:scope.Id
            };
            this.setRow=scope;
            this.addSwipeRecordVisible=true;
        },
        remoteMethod(query) {
            if (query !== '') {
                this.shopLoading = true;
                shopQuery({queryTxt:query},(res)=>{
                    this.shopLoading = false;
                    this.shopList=res.Result;
                });
            } else {
                this.shopList = [];
            }
        },
        // jump(scope){
        //     this.$router.push({path:'/home',query: {id:'1'}})
        // },
        showChild(scope){
            this.setRow=scope;
            swipeGetChild({swipeId:scope.Id},(res)=>{
                this.childs=res.Result;
                this.childVisible=true;
            })
        },
        getContact(scope){
            this.repeatContacts=[];
            this.setRow=scope;
            swipeGetContact({swipeId:scope.Id},(res)=>{
                this.contacts=res.Result;
                this.contactsTableData=res.Result;
                this.contactVisible=true;
            })
        },
        fail(scope){
            this.$confirm('确认不通过吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                swipeFail({swipeId:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.Status=4;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        passAction(scope,grade){
            this.$confirm('确认通过并且设置为 '+grade+' （级）刷手吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    swipePass({
                        swipeId:scope.Id,
                        grade:grade
                        },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.setRow.Grade=grade;
                            this.setRow.InitialGrade=grade;
                            this.setRow.Status=1;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
        },
        enable(scope){
            this.$confirm('确认解封该用户吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                swipeEnable({swipeId:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '解封成功',
                            type: 'success'
                        });
                        scope.Status=1;
                    }else{
                        this.$message.error("系统错误，请稍后再试");
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        clearScript(scope){
            this.$confirm('确认清理该用户脚本吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                swipeClearScript({swipeId:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '清理成功',
                            type: 'success'
                        });
                        scope.Status=1;
                    }else{
                        this.$message.error("系统错误，请稍后再试");
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        deactivate(scope){
            this.$prompt('请输入封号原因', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\S/,
            inputErrorMessage: '封号原因不能为空'
            }).then(({ value }) => {
                swipeDisable({swipeId:scope.Id,reason:value},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '封停成功',
                            type: 'success'
                        });
                        scope.Status=5;
                        scope.Reason=value;
                    }else{
                        this.$message.error("系统错误，请稍后再试");
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
        query(){
            this.isLoading=true;
            swipeGet({
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                queryTxt:this.queryModel.queryTxt,
                status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
                grade:this.queryModel.grade==""?0:parseInt(this.queryModel.grade),
                managerId:this.queryModel.managerId==""?0:parseInt(this.queryModel.managerId),
                createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes),
                reviewTimes:this.queryModel.reviewTimes==null?"[]":JSON.stringify(this.queryModel.reviewTimes),
                isNever:this.queryModel.isNever,
                souce:this.queryModel.souce==""?0:parseInt(this.queryModel.souce),
                myFission:this.queryModel.myFission,
                hasMeWechat:this.queryModel.hasMeWechat
            },(res)=>{
                this.tableData=res.Result.List;
                this.moneyTotal=res.Result.Total;
                this.total=res.TotalCount;
                this.isLoading=false;
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:20,
                pIndex:1,
                status:"",
                grade:"",
                createTimes:[],
                managerId:"",
                isNever:false,
                reviewTimes:[],
                souce:"",
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        },

    }
}
</script>
<style scoped>
.tag_btn{
    cursor: pointer;
}
.amap-wrapper {
  width: 100%;
  height: 500px;
}

</style>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>